import './animation.less';
import PropTypes from 'prop-types';
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

const Animate = ({ children }) => {
	return (
		<ReactCSSTransitionGroup transitionName="custom-animation-opacity"
			transitionEnterTimeout={300}
			transitionLeave={false}
			transitionAppear={true}
			transitionAppearTimeout={500}>
			{ children }
		</ReactCSSTransitionGroup>
	);
};

Animate.propTypes = {
	children: PropTypes.node
};

export default Animate;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/animation.js